import { cn } from "../lib/cn";

export type Tone = "neutral" | "success" | "warning" | "danger" | "info" | "brand";

const tones: Record<Tone, string> = {
  neutral: "bg-[var(--surface-sunken)] text-[var(--text-secondary)]",
  success: "bg-success-500/15 text-success-600",
  warning: "bg-warning-500/15 text-warning-600",
  danger: "bg-danger-500/15 text-danger-600",
  info: "bg-info-500/15 text-info-600",
  brand: "bg-[var(--accent-soft)] text-[var(--accent-soft-text)]",
};

/**
 * One place that maps a backend status string to a colour, so ACTIVE never reads
 * green on one screen and grey on the next.
 */
const statusTones: Record<string, Tone> = {
  ACTIVE: "success",
  COMPLETED: "success",
  APPROVED: "success",
  VERIFIED: "success",
  LIVE: "success",
  TRIAL: "info",
  PENDING: "warning",
  PENDING_VERIFICATION: "warning",
  PROVISIONING: "warning",
  PAST_DUE: "warning",
  DRAFT: "neutral",
  ARCHIVED: "neutral",
  CANCELLED: "neutral",
  CLOSED: "neutral",
  SUSPENDED: "danger",
  FAILED: "danger",
  REJECTED: "danger",
};

export function toneForStatus(status: string): Tone {
  return statusTones[status.toUpperCase()] ?? "neutral";
}

export function StatusBadge({ status, tone }: { status: string; tone?: Tone }) {
  const resolved = tone ?? toneForStatus(status);
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-[var(--radius-pill)] px-2 py-0.5 text-2xs font-semibold uppercase tracking-wide",
        tones[resolved],
      )}
    >
      {status.replace(/_/g, " ").toLowerCase()}
    </span>
  );
}
